import React from 'react';
import { Label, Row, Col, ReactSelectBox, Quantity, PrimaryButton, OutlineButton } from 'client/CommonComponents';
import { CONSTANTS } from "client/utils/constants";
import CancelConfirmationPopup from 'client/CommonComponents/DialogBox/CancelConfirmationPopup';
import { isMaxLength } from 'utils';
import permissions, { isAuthorized } from 'client/utils/Permissions';

const ProductionVehicle = (props: any) => {

  const {
    fuelTypeOnChange,
    selectedFuelType,
    showDropDown,
    dropDownValues,
    showAddItem } = props
  
  const vehicleOnChange = props.vehicleOnChange;
  const vehicleCapacityOnChange = props.vehicleCapacityOnChange;
  const noOfDoorsOnChange = props.noOfDoorsOnChange;
  const upfitOptionOnChange = props.upfitOptionOnChange;
  const driveTrainOnChange = props.driveTrainOnChange;
  const snowSetupOnChange = props.snowSetupOnChange;
  const quantityIncrement = props.quantityIncrement;
  const quantityDecrement = props.quantityDecrement;
 
  const addOnClick = props.addOnClick;
  const productionVehicleValidation = props.productionVehicleValidation;
  const selectedVehicleType = props.selectedVehicleType;
  const selectedVehicleCapacity = props.selectedVehicleCapacity;
  const selectedNoOfDoors = props.selectedNoOfDoors;
  const selectedUpfitOption = props.selectedUpfitOption;
  const selectedDriveTrain = props.selectedDriveTrain;
  const selectedSnowSetup = props.selectedSnowSetup
  const selectedQuantity = props.selectedQuantity;
  const hideDialog = props.hideDialog;
  const Popupcontent = props.Popupcontent;  
  const quantityOnChange = props.quantityOnChange;
  const updateOnClick = props.updateOnClick;
  const isEditRequestClick = props.isEditRequestClick
  const cancelEditRequestType = props.cancelEditRequestType

    return <div className='p-3'>
    <Row>
    {showDropDown?.showUpfitOption ?
      <Col xs={12} sm={4} md={4} lg={4} className='mb-md-3 mb-2'>
        <Label required data-attribute="ProductionVehicle_Default_Label">Upfit Option</Label>
        <ReactSelectBox
          options={dropDownValues?.upfitOptionDropDown}
          onChange={(item: any) => upfitOptionOnChange(item)}
          value={selectedUpfitOption}
          className={productionVehicleValidation.UpfitOptionError.length > 0 ? 'controlValidation' : ""}
          selectRef={(element: any) => props.ProductionFieldRef.current[3] = element}
         data-attribute="ProductionVehicle_Default_SearchSelectBox" />
        {productionVehicleValidation.UpfitOptionError.length > 0 ? <p className='validMessage'>{productionVehicleValidation.UpfitOptionError}</p> : null}
      </Col>
      : null }
      {showDropDown?.showSnowSetup ?
      <Col xs={12} sm={4} md={4} lg={4} className='mb-md-3 mb-2'>
        <Label required data-attribute="ProductionVehicle_Default_Label_2">Snow Setup</Label>
        <ReactSelectBox
          options={dropDownValues?.snowSetupDropDown}
          onChange={(item: any) => snowSetupOnChange(item)}
          value={selectedSnowSetup}
          className={productionVehicleValidation.SnowSetupError.length > 0 ? 'controlValidation' : ""}
          selectRef={(element: any) => props.ProductionFieldRef.current[3] = element}
         data-attribute="ProductionVehicle_Default_SearchSelectBox_2" />
        {productionVehicleValidation.SnowSetupError.length > 0 ? <p className='validMessage'>{productionVehicleValidation.SnowSetupError}</p> : null}
      </Col>
      : null }
      {showDropDown?.showVehicle ?
      <Col xs={12} sm={4} md={4} lg={4} className='mb-md-0 mb-2'>
        <Label required data-attribute="ProductionVehicle_Default_Label_3">Vehicle</Label>
        <ReactSelectBox
          options={dropDownValues?.vehicleDropDown}
          onChange={(item: any, e: any) => vehicleOnChange(e, item)}
          value={selectedVehicleType}       
          name={selectedVehicleType.value}
          selectRef={(element: any) => props.ProductionFieldRef.current[0] = element}
          className={productionVehicleValidation.VehicleError.length > 0 ? 'controlValidation' : ''}
         data-attribute="ProductionVehicle_value_SearchSelectBox" />
        {productionVehicleValidation.VehicleError.length > 0 ? <p className='validMessage'>{productionVehicleValidation.VehicleError}</p> : null}
      </Col>
      : null}
      {selectedVehicleType?.showVehicleCapacity && showDropDown?.showVehicleCapacity ?
      <Col xs={12} sm={4} md={4} lg={4} className='mt-2 mt-sm-0 mb-md-0 mb-2'>
        <Label required data-attribute="ProductionVehicle_Default_Label_4">Vehicle Capacity</Label>
        <ReactSelectBox
          options={dropDownValues?.vehicleCapacityDropDown}
          onChange={(item: any, e: any) => vehicleCapacityOnChange(e, item)}
          value={selectedVehicleCapacity}
          name={selectedVehicleCapacity.value}
          className={productionVehicleValidation.VehicleCapacityError.length > 0 ? 'controlValidation' : ''}
          selectRef={(element: any) => props.ProductionFieldRef.current[1] = element}

         data-attribute="ProductionVehicle_value_SearchSelectBox_2" />
        {productionVehicleValidation.VehicleCapacityError.length > 0 ? <p className='validMessage'>{productionVehicleValidation.VehicleCapacityError}</p> : null}
      </Col> : null}
      {showDropDown?.showNoOfDoor ?
      <Col xs={12} sm={4} md={4} lg={4} className='mt-2 mt-sm-0 mb-sm-3 mb-3'>
        <Label required data-attribute="ProductionVehicle_Default_Label_5"># of Doors</Label>
        <ReactSelectBox
          options={dropDownValues?.noOfDoorDropDown}
          onChange={(item: any, e: any) => noOfDoorsOnChange(e, item)}
           value={selectedNoOfDoors}
          name={selectedNoOfDoors.value}
          selectRef={(element: any) => props.ProductionFieldRef.current[2] = element}
          className={productionVehicleValidation.NoOfDoorsError.length > 0 ? 'controlValidation' : ''}
         data-attribute="ProductionVehicle_value_SearchSelectBox_3" />
        {productionVehicleValidation.NoOfDoorsError.length > 0 ? <p className='validMessage'>{productionVehicleValidation.NoOfDoorsError}</p> : null}
      </Col>
      : null}
      {showDropDown?.showDriveTrain ?
      <Col xs={12} sm={4} md={4} lg={4} className='mb-md-3 mb-2'>
        <Label required data-attribute="ProductionVehicle_Default_Label_6">Drive Train</Label>
        <ReactSelectBox
          options={dropDownValues?.driveTrainDropDown}
          onChange={(item: any) => driveTrainOnChange(item)}
          value={selectedDriveTrain}
          selectRef={(element: any) => props.ProductionFieldRef.current[4] = element}
          className={productionVehicleValidation.DriveTrainError.length > 0 ? 'controlValidation' : ''}
         data-attribute="ProductionVehicle_Default_SearchSelectBox_3" />
        {productionVehicleValidation.DriveTrainError.length > 0 ? <p className='validMessage'>{productionVehicleValidation.DriveTrainError}</p> : null}
      </Col>
      : null}
      {showDropDown?.showFuelType ?
      <Col xs={12} sm={4} md={4} lg={4} className='mb-md-3 mb-2'>
        <Label data-attribute="ProductionVehicle_Default_Label_7">Fuel Type</Label>
        <ReactSelectBox
          options={dropDownValues?.fuelTypeDropDown}
          onChange={(item: any) => fuelTypeOnChange(item)}
          value={selectedFuelType}
          selectRef={(element: any) => props.ProductionFieldRef.current[5] = element}
          className={productionVehicleValidation?.FuelTypeError?.length > 0 ? 'controlValidation' : ''}
         data-attribute="ProductionVehicle_Default_SearchSelectBox_4" />
      </Col>
      :null }
      <Col xs={10} sm={10} md={10} lg={10} className='mb-1'>
        {!isEditRequestClick &&
        <>
          <Label required data-attribute="ProductionVehicle_Default_Label_8">Quantity</Label>
          <Quantity
          increment={quantityIncrement}
            onKeyPress={(event: any) => { isMaxLength(event, 2) }}
          onBlur={props.onBlur}
          onChange={quantityOnChange} 
          disableFlg={selectedQuantity <= 1} decrement={quantityDecrement} value={selectedQuantity} 
            inputRef={(element: any) => props.ProductionFieldRef.current[6] = element}
           data-attribute="ProductionVehicle_Default_Quantity" />
          {productionVehicleValidation.QtyError.length > 0 ? <p className='validMessage'>{productionVehicleValidation.QtyError}</p> : null}
        </>
        }
        
      </Col>
      <Col xs={2} sm={2} md={2} lg={2} className='mb-1'>
        <div className='pull-right rightAdd'>
          {!isEditRequestClick ?
            showAddItem && <PrimaryButton text='Add Item' onClick={addOnClick} btnRef={(element: any) => props.ProductionFieldRef.current[7] = element} data-attribute="ProductionVehicle_Default_Button"></PrimaryButton>
            : <div className='editTypeBtnBlock'>
             {showAddItem && <PrimaryButton text='Update Request' onClick={updateOnClick} className='me-2' disabled={!isAuthorized(permissions.RequisitionsCreateUpdate) || !isAuthorized(permissions.CreateUpdateTransfers)} data-attribute="ProductionVehicle_Default_Button_2"></PrimaryButton>}
              <OutlineButton text='Cancel Request' onClick={cancelEditRequestType} className='me-0' disabled={!isAuthorized(permissions.RequisitionsCreateUpdate) || !isAuthorized(permissions.CreateUpdateTransfers)}  data-attribute="ProductionVehicle_Default_Button_3" />
            </div>
          }
        </div>
      </Col>
    </Row>

    { Popupcontent.isDialogVisible &&
      <CancelConfirmationPopup
        hideDialog={!Popupcontent.isDialogVisible}
        onDismiss={hideDialog}
        Popupcontent={Popupcontent}
        popupOutlinebtnOnclick={() => Popupcontent.popupOutlinebtnOnclick()}
        popupPrimarybtnOnclick={() => Popupcontent.popupPrimarybtnOnclick}
      />
    }
        
  </div>
}

export default ProductionVehicle;

